/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.deleteMessageForSelf'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  convoId: /*#__PURE__*/ l.string(),
  messageId: /*#__PURE__*/ l.string(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<ConvoDefs.DeletedMessageView>(
    (() => ConvoDefs.deletedMessageView) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Marks a message as deleted for the viewer, so they won't see that message in future enumerations. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidConvo',
  'MessageDeleteNotAllowed',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
